import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken, RadiusToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon/Icon";
import { LoaderAnimated, LoaderSize } from "components/loader";
import { Shortcuts } from "components/shortcuts";
import { KeyCodeEnum } from "constants/keyCode";
import { HiddenInput } from "routes/styled";
import { withVar } from "themes/helpers";

interface IProps {
  value: string;
  onChange(nextValue: string): void;
  onSubmit?(nextValue: string): void;
  onClear?(): void;
  focusedOnInit?: boolean;
  placeholder?: string;
  isLoading?: boolean;
}

interface IState {
  isTyping: boolean;
  isInputFocused: boolean;
}

const StyledContainer = styled.div`
  position: relative;
`;

interface ICloseButtonProps {
  isVisible?: boolean;
  isInputFocused?: boolean;
}

const StyledButton = styled.button<ICloseButtonProps>`
  position: absolute;
  top: 0;
  height: 40px;
  padding: 0 13px;
  border: none;
  background: none;
  cursor: pointer;
`;

const StyledButtonClose = styled(StyledButton)<ICloseButtonProps>`
  right: 0;
  visibility: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.isVisible ? "visible" : "hidden")
  };
  opacity: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.isVisible ? 1 : 0)
  };
  transition: all 0.2s ease-in-out;
`;

const StyledButtonSearch = styled(StyledButton)<ICloseButtonProps>`
  left: 0;
  svg {
    fill: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) =>
        withVar(props.isInputFocused ? DesignToken.ActionPrimaryDefault : DesignToken.ContentBasicSecondary)
    };
    transition: fill 0.2s ease-in-out;
  }
`;

const StyledInput = styled.input`
  display: inline-block;
  width: 100%;
  height: 40px;
  padding: 0 36px;
  font-size: 14px;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  text-align: left;
  border-radius: var(${RadiusToken.Radius3});
  border: solid 1px ${withVar(DesignToken.BorderBasicPrimary)};
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
  box-sizing: border-box;
  transition: border 0.2s ease-in-out;

  ::placeholder {
    color: ${withVar(DesignToken.ContentBasicDisabled)};
    opacity: 1;
  }

  ::-ms-clear {
    display: none;
  }

  &:hover {
    border-color: ${withVar(DesignToken.BorderBasicHover)};
    transition: border 0.2s ease-in-out;
  }

  &:focus,
  &:active {
    outline: none;
    border-color: ${withVar(DesignToken.ActionPrimaryDefault)};
    transition: border 0.2s ease-in-out;
  }
`;

const LoaderContainer = styled.div`
  width: 15px;
  height: 15px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 13px;
`;

export class SearchInput extends React.Component<IProps, IState> {
  static defaultProps = {
    focusedOnInit: false,
  };

  // @ts-expect-error TS(2416): Property 'state' in type 'SearchInput' is not assi... Remove this comment to see the full error message
  state = {
    isTyping: false,
    isInputFocused: this.props.focusedOnInit,
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidMount() {
    if (this.state.isInputFocused && this.inputRef.current) {
      this.inputRef.current.focus();
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentWillUnmount() {
    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setIsTyping = (isTyping: boolean) => this.setState({ isTyping });
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleInputFocus = () => this.setState({ isInputFocused: true });
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleInputBlur = () => this.setState({ isInputFocused: false });

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleClear = () => {
    this.props.onChange("");
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    this.inputRef.current.focus();

    if (this.props.onClear) {
      this.props.onClear();
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  handleChange = (e: any) => {
    const { value } = e.target;
    this.setIsTyping(true);

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }
    // @ts-expect-error TS(2322): Type 'Timeout' is not assignable to type 'null'.
    this.typingTimeout = setTimeout(() => {
      this.setIsTyping(false);
    }, 1000);
    this.props.onChange(value);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (this.props.onSubmit) {
      this.props.onSubmit(this.props.value);
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private handleSearchBarFocusShortcut = () => {
    if (!this.state.isInputFocused) {
      setTimeout(() => {
        // @ts-expect-error TS(2531): Object is possibly 'null'.
        this.inputRef.current.focus();
      }, 0);
    }
  };

  private shortcutsConfig = {
    [KeyCodeEnum.Slash]: {
      eventHandler: this.handleSearchBarFocusShortcut,
    },
  };

  typingTimeout = null;
  inputRef: React.RefObject<HTMLInputElement> = React.createRef();

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    return (
      <StyledContainer>
        <form onSubmit={this.handleSubmit}>
          <Shortcuts config={this.shortcutsConfig}>
            <StyledInput
              type="search"
              inputMode="search"
              ref={this.inputRef}
              value={this.props.value}
              onChange={this.handleChange}
              placeholder={this.props.placeholder}
              onFocus={this.handleInputFocus}
              onBlur={this.handleInputBlur}
            />
            <HiddenInput type="submit" />
          </Shortcuts>
          <LoaderContainer>
            {/* @ts-expect-error TS(2322) */}
            <LoaderAnimated size={LoaderSize.Small} isVisible={this.props.isLoading} />
          </LoaderContainer>
          <StyledButtonSearch
            isInputFocused={this.state.isInputFocused || this.props.value !== ""}
            disabled
            title="Search"
          >
            <Icon name={IconsEnum.Search} width="15px" height="15px" />
          </StyledButtonSearch>
          <StyledButtonClose
            isVisible={!this.props.isLoading && this.props.value !== "" && !this.state.isTyping}
            onClick={this.handleClear}
            title="Clear"
          >
            <Icon name={IconsEnum.Close} fill={withVar(DesignToken.ActionPrimaryDefault)} width="12px" height="12px" />
          </StyledButtonClose>
        </form>
      </StyledContainer>
    );
  }
}
